<template>
  <pt-batch-operation-form class="pt-batch-operation-form__page"></pt-batch-operation-form>
</template>

<script>
import PtBatchOperationForm from 'cps/adult-sell-order/pt-batch-operation/pt-batch-operation-form/withData'
export default {
  name: 'pt-batch-operation-form__view',
  components: {
    'pt-batch-operation-form': PtBatchOperationForm
  }
}
</script>
